import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import SubscriptionValidResult from '@/SubscriptionValidResult';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import User from '@/User';
import QueryStringUtility from './QueryStringUtility';
import GoogleLoginResponse from '@/GoogleLoginResponse';

export class LoginServiceStatic {
    checkSubscription(): Promise<AxiosResponse<SubscriptionValidResult>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/checksubscription`
        return AxiosPostProcessor.postProcess(Axios.get<SubscriptionValidResult>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    googleLogin(code: string): Promise<AxiosResponse<GoogleLoginResponse>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/googlelogin${QueryStringUtility.getQueryString({code})}`
        return AxiosPostProcessor.postProcess(Axios.get<GoogleLoginResponse>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    loginGet(): Promise<AxiosResponse<User>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/login`
        return AxiosPostProcessor.postProcess(Axios.get<User>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    loginPostUrl() { return `${process.env.VUE_APP_BASE_URL_API}/api/login`; }

    removeSubscriptionInfo(): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/removesubscriptioninfo`
        return AxiosPostProcessor.postProcess(Axios.get(url, AxiosDefaultRequestConfig.merge({ })));
    }
}
const LoginService = new LoginServiceStatic();
export default LoginService;
